import { Avatar, AvatarProps } from '@jurnee/common/src/components/primitives/Avatar';

interface Props extends AvatarProps {
  user: { firstName: string | null, lastName: string | null, imageUrl?: string | null };
}

export default function(props: Props) {
  return (
    <Avatar
      name={`${props.user?.firstName || '?'} ${props.user?.lastName || '?'}`}
      src={props.user?.imageUrl}
      {...props}
    />
  );
}